(function () {
    'use strict';

    angular
        .module('bozorakaAdminApp')
        .controller('TicketOrderController', TicketOrderController);

    TicketOrderController.$inject = ['$scope', '$state', '$uibModal', 'TicketPayment', 'ProfileIdByPhone'];

    function TicketOrderController($scope, $state, $uibModal, TicketPayment, ProfileIdByPhone) {
        var vm = this;

        vm.itemsPerPage = 10;
        vm.page = 1;
        vm.maxPage = 1;
        vm.totalItems = 0;

        vm.ticketPayments = [];
        vm.loading = false;

        vm.searchQuery = {
            field: null,
            status: null,
            fromDate: null,
            toDate: null
        };

        vm.loadPage = loadPage;
        vm.transition = transition;
        vm.search = search;
        vm.clear = clear;
        vm.openProfile = openProfile;
        vm.openTicketDetails = openTicketDetails;

        init();
        initDatePicker();

        function init() {
            loadPage(1);
        }

        function initDatePicker() {
            var pagingParams = angular.copy(vm.searchQuery) || {};

            $('.input-daterange input').each(function () {
                var name = $(this).attr('name');
                if (name === 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                }
                if (name === 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            $('.date-picker').datepicker({
                autoclose: true,
                todayHighlight: true,
                clearBtn: true
            })

                .on('changeDate', 'input[name="from"]', function (e) {
                    $scope.$applyAsync(function () {
                        vm.searchQuery.fromDate = moment(e.date).format('MM/DD/YYYY');
                        pagingParams.fromDate = vm.searchQuery.fromDate;
                    });
                })

                .on('changeDate', 'input[name="to"]', function (e) {
                    $scope.$applyAsync(function () {
                        vm.searchQuery.toDate = moment(e.date).format('MM/DD/YYYY');
                        pagingParams.toDate = vm.searchQuery.toDate;
                    });
                });
        }

        function buildParams(page) {
            var pagingParams = angular.copy(vm.searchQuery) || {};

            var params = {
                valueInt1: page,
                size: vm.itemsPerPage,

                field: pagingParams.field,
                valueString1: pagingParams.status,
                fromDate: pagingParams.fromDate,
                toDate: pagingParams.toDate
            };

            Object.keys(params).forEach(function (k) {
                if (params[k] === null || params[k] === undefined || params[k] === '') {
                    delete params[k];
                }
            });

            return params;
        }

        function loadPage(page) {
            if (page < 1) page = 1;
            if (vm.maxPage && page > vm.maxPage) page = vm.maxPage;

            vm.loading = true;

            loadAll(page);
        }

        function loadAll(page) {
            TicketPayment.queryFromMySafar(buildParams(page), onSuccess, onError);
            function onSuccess(data) {

                vm.ticketPayments = data.result || [];
                vm.page = data.page || page;

                vm.totalItems = data.count || 0;
                vm.maxPage = data.max_page || Math.max(1, Math.ceil(vm.totalItems / vm.itemsPerPage));
            }
            function onError(error) {
                AlertService.error(error.data.message);
            }
        }

        function transition() {
            loadPage(vm.page);
        }

        function search() {
            vm.page = 1;
            loadPage(1);
        }

        function clear() {
            vm.searchQuery = {
                field: null,
                status: null,
                toDate: null,
                fromDate: null
            };
            $('.input-daterange input').each(function () {
                var name = $(this).attr('name');
                if (name === 'from') {
                    $(this).val(vm.searchQuery.fromDate);
                }
                if (name === 'to') {
                    $(this).val(vm.searchQuery.toDate);
                }
            });

            vm.page = 1;
            loadPage(1);
        }

        function openProfile(phoneNumber) {
            ProfileIdByPhone.get({phoneNumber: phoneNumber}, onSuccess);

            function onSuccess(data) {
                $state.go('profile-detail', {id: data.profileId});
            }
        }

        function openTicketDetails(ticket) {
            $uibModal.open({
                templateUrl: 'app/entities/ticket-payment/ticket-order-detail-dialog.html',
                controller: 'TicketOrderDetailDialogController',
                controllerAs: 'vm',
                backdrop: 'static',
                size: 'lg',
                windowClass: 'ticket-order-detail-dialog-xl',
                resolve: {
                    selectedTicket: ticket
                }
            });
        }

    }
})();
